import { render, staticRenderFns } from "./NewReportAlert.vue?vue&type=template&id=71663616&scoped=true&"
import script from "./NewReportAlert.vue?vue&type=script&lang=js&"
export * from "./NewReportAlert.vue?vue&type=script&lang=js&"
import style0 from "./NewReportAlert.vue?vue&type=style&index=0&id=71663616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71663616",
  null
  
)

export default component.exports